<!--お知らせ一览-->
<template>
  <div>
    <el-card class="b0001-box-card">
      <!-- 表头文字 -->
      <el-row :gutter="0" style="margin-top:8px">
        <!-- お知らせ -->
        <div class="table-header">{{$t('MODULE.B0001_LBL_INFORM')}}</div>
      </el-row>
      <el-table :data="tNoticeDetail" :show-header="false" style="width: 100%" @row-click="rowClick">
        <el-table-column prop="value" label="" width="25px">
          <template slot-scope="scope">
            <span style="color:#409EFF;font-size:25px" v-if="scope.row.confirmFlag=='0'">●</span>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="">
          <template slot-scope="scope">
            <div>
              <!-- タイトル -->
              <span class="b0001-noticeTitle" :style="{width:clientWidth-150+'px'}">{{scope.row.mailTitle}}</span>
              <!-- 配信日 -->
              <div style="float:right;margin-right:0px">{{scope.row.mailDate}}</div>
            </div>
            <!-- 内容 -->
            <div class="b0001-mailContents"> {{scope.row.mailContents}} </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import css from "@/statics/css"
import utilApi from '@/common/utils'
import * as amsApi from "../api/b_0001"
let url = require("@/../config/sysConfig")
import i18n from '@/message/i18n.js'
export default {
  mixins: [css],
  name: '',
  data() {
    return {
      userCd: '',//login-userCd
      tNoticeDetail: [],
      saveParams: {},
      clientWidth: 0
    }
  },

  created() {
    this.clientWidth = document.body.clientWidth
    window.localStorage.removeItem(url.routerUrl_B0001)
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
    this.query()
  },

  methods: {
    // お知らせ一覧情報を取得する
    query() {
      //实现Loading 加载方法
      this.set_loading()
      amsApi.noticeDetailGet(this.userCd).then(res => {
        if (res.code == '300') {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true });//該当データはありません。
        } else {
          this.tNoticeDetail = res.items.tNoticeDetail
          var mailNum = 0
          for (var item of this.tNoticeDetail) {
            if (item.confirmFlag == '0') {
              mailNum++
            }
          }
          // 未确认通知数更新
          this.$store.commit('mailNum', mailNum)
          for (var item of this.tNoticeDetail) {
            if (item.mailDate) {
              item.mailDate = utilApi.timeDefault(item.mailDate)
            }
          }
        }
        this.close_loading()
      }).catch((err) => {
        this.close_loading()
      });
    },

    // お知らせ一覧情報を確認する
    noticeConfirm() {
      var params = []
      params.push(this.saveParams)
      amsApi.noticeSave(params, this.userCd).then(res => {
        if (res.code == '202') {
          var mailNum = 0
          mailNum = this.$store.state.mailNum
          // 更新メニュー欄のメッセージアイコンに未確認件数
          this.$store.commit('mailNum', mailNum - 1)
        } else if (res.code == '311') {
          this.$message.error({ message: i18n.$t('COMMON.CURD_ERROR'), showClose: true });//更新失敗になる
        }
      })
    },

    // 明細行选择
    rowClick(row) {
      this.noticeCd = row.noticeCd
      this.saveParams.noticeCd = row.noticeCd
      this.saveParams.userId = this.userCd
      this.saveParams.processDiv = '4'
      this.saveParams.editFlg = '1'
      if (row.confirmFlag == '0') {
        this.noticeConfirm()
      }
      this.$router.push({ path: url.routerUrl_B0002, query: { userCd: this.userCd, noticeCd: this.noticeCd } })
    },
  },

  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.clientWidth = document.body.clientWidth
        that.clientWidth = window.clientWidth
      })()
    }
  },

  watch: {
    // 监听窗口宽度变化
    clientWidth(val) {
      if (!this.timer) {
        // 一旦监听到的clientWidth值改变，就将其重新赋给data里的clientWidth
        this.clientWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // 打印clientWidth变化的值
          that.timer = false
        }, 400)
      }
    }
  },
}
</script>
<style>
.b0001-box-card .el-table .cell {
  padding-left: 0px;
}

.b0001-box-card .el-card__body {
  padding: 0;
}
.b0001-box-card .el-card__header {
  padding: 8px;
  font-size: 14px;
}
.b0001-box-card {
  height: 100%;
}

/* div显示两行，超过显示省略号 */
.b0001-mailContents {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.b0001-noticeTitle {
  line-height: 1;
  color: rgb(66, 66, 66);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/module/page/b_0001.vue